module.exports = __webpack_public_path__ + "static/img/star_person_service.1ad13dbd.png";